const tr = {
  // Nav
  "nav.expos": "Fuarlar",
  "nav.map": "Harita",
  "nav.ai": "AI",
  "nav.notes": "Notlar",
  "nav.profile": "Profil",

  // Splash
  "splash.tagline": "Daha akıllı gezin. Daha iyi bağlan.",
  "splash.tag.ai": "AI Destekli",
  "splash.tag.realtime": "Gerçek Zamanlı",
  "splash.tag.nav": "Akıllı Navigasyon",
  "splash.stat.expos": "Fuar",
  "splash.stat.booths": "Stand",
  "splash.stat.accuracy": "Doğruluk",
  "splash.trusted": "Dünya genelinde 45.000+ profesyonel tarafından güvenilir",
  "splash.btn.enter": "Uygulamaya Gir",
  "splash.btn.demo": "Demo'yu Keşfet",

  // Expo Selection
  "expoSelect.title": "Fuarları Keşfet",
  "expoSelect.subtitle.events": "etkinlik mevcut",
  "expoSelect.search.placeholder": "Fuar, şehir, kategori ara...",
  "expoSelect.filter.all": "Tümü",
  "expoSelect.filter.active": "Aktif",
  "expoSelect.filter.upcoming": "Yakında",
  "expoSelect.filter.past": "Geçmiş",
  "expoSelect.featured": "Öne Çıkan • Şu An Canlı",
  "expoSelect.allEvents": "Tüm Etkinlikler",
  "expoSelect.live": "CANLI",
  "expoSelect.booths": "Stand",
  "expoSelect.attendees": "Katılımcı",
  "expoSelect.halls": "Salon",
  "expoSelect.enter": "Gir",
  "expoSelect.noResults": "Aramanızla eşleşen fuar bulunamadı",
  "status.active": "Aktif",
  "status.upcoming": "Yakında",
  "status.past": "Geçmiş",

  // Map
  "map.title": "Fuar Haritası",
  "map.subtitle": "World Tech Summit 2026 • Dubai",
  "map.coverage": "Fuar Kapsamı",
  "map.legend.visited": "Ziyaret Edildi",
  "map.legend.recommended": "Önerilenler",
  "map.legend.important": "Önemli",
  "map.legend.nonsponsored": "Sponsorsuz",
  "map.entrance": "GİRİŞ",
  "map.stat.visited": "Ziyaret Edildi",
  "map.stat.suggested": "Önerilen",
  "map.stat.total": "Toplam",

  // Booth Detail
  "booth.score": "AI Eşleşme Skoru",
  "booth.contact": "İletişim",
  "booth.markVisited": "Ziyaret Et",
  "booth.visited": "Ziyaret Edildi",
  "booth.markImportant": "Önemli İşaretle",
  "booth.important": "Önemli",
  "booth.whyAI": "Neden AI?",
  "booth.aiReasoning": "AI Analizi",
  "booth.quickNote": "Hızlı Not",
  "booth.notePlaceholder": "Bu stand hakkında not ekleyin...",
  "booth.saveNote": "Notu Kaydet",
  "booth.noteSaved": "✓ Not Kaydedildi!",
  "booth.limitedInfo": "Tam bilgi sponsorlu standlar için mevcuttur",
  "booth.limitedAI": "Bu standın AI içgörüleri için yükseltin.",
  "sponsor.platinum": "✦ Platin Sponsor",
  "sponsor.gold": "★ Altın Sponsor",
  "sponsor.standard": "Standart",
  "sponsor.none": "Sponsorsuz",

  // AI Screen
  "ai.title": "AI Önerileri",
  "ai.subtitle": "Profilinize özel • Canlı güncelleme",
  "ai.active": "ExpoFlow AI aktif",
  "ai.analyzing": "420 stand analiz ediliyor • İlgi alanlarınız eşleştiriliyor",
  "ai.mustVisit": "Mutlaka Ziyaret Et",
  "ai.nearby": "Yakın Fırsatlar",
  "ai.notVisited": "Henüz Ziyaret Edilmedi",
  "ai.stat.mustVisit": "Zorunlu Ziyaret",
  "ai.stat.nearby": "Yakında",
  "ai.stat.unexplored": "Keşfedilmedi",
  "ai.score": "skor",
  "ai.allDone": "Her şeyi keşfettiniz!",
  "ai.allDoneDesc": "Tüm önerilen standlar ziyaret edildi.",

  // Progress
  "progress.title": "İlerleme & Kapsam",
  "progress.subtitle": "World Tech Summit 2026 • Keşif raporu",
  "progress.explored": "Keşfedildi",
  "progress.coverage": "Fuar Kapsamı",
  "progress.visitedOf": "ziyaret edildi / toplam stand",
  "progress.stat.visited": "Ziyaret",
  "progress.stat.important": "Önemli",
  "progress.stat.remaining": "Kalan",
  "progress.byHall": "Salona Göre",
  "progress.missedTitle": "Önemli Ama Ziyaret Edilmemiş Standlar",
  "progress.passedTitle": "Daha Önce Geçtiğiniz Standlar",
  "progress.noVisited": "Henüz ziyaret edilen stand yok. Keşfetmeye başlayın!",
  "progress.analytics": "Analitik",
  "progress.time": "Fuarda Süre",
  "progress.distance": "Yürünen Mesafe",
  "progress.connections": "Kurulan Bağlantılar",
  "progress.notes": "Alınan Not",
  "progress.backToMap": "Haritaya Dön",

  // Notes
  "notes.title": "Toplantı Notları",
  "notes.subtitle": "şirket kaydı takip ediliyor",
  "notes.add": "Ekle",
  "notes.filter.all": "Tümü",
  "notes.status.visited": "Ziyaret Edildi",
  "notes.status.followup": "Takip Et",
  "notes.status.interested": "İlgileniyorum",
  "notes.status.notRelevant": "İlgisiz",
  "notes.updateStatus": "Durumu Güncelle",
  "notes.editNote": "Notu Düzenle",
  "notes.share": "Paylaş",
  "notes.noNotes": "Burada not yok",
  "notes.noNotesDesc": "Stand ziyaret edin ve toplantılarınızı takip etmek için not alın",
  "notes.save": "Kaydet",
  "notes.cancel": "İptal",

  // Profile
  "profile.title": "Profil & Ayarlar",
  "profile.edit": "Düzenle",
  "profile.jobTitle": "Teknoloji VP'si • InnovateTech GmbH",
  "profile.proMember": "Pro Üye",
  "profile.theme": "Uygulama Teması",
  "profile.theme.dark": "Karanlık Tech",
  "profile.theme.light": "Premium Açık",
  "profile.industry": "Endüstri Odağı",
  "profile.industry.selected": "seçildi",
  "profile.interests": "İlgi Alanları & Hedefler",
  "profile.notifications": "Bildirimler",
  "profile.notif.ai": "AI Önerileri",
  "profile.notif.ai.desc": "Kişiselleştirilmiş stand önerileri alın",
  "profile.notif.booth": "Stand Güncellemeleri",
  "profile.notif.booth.desc": "Kaydedilen standlar için gerçek zamanlı uyarılar",
  "profile.notif.reminders": "Toplantı Hatırlatıcıları",
  "profile.notif.reminders.desc": "Toplantı ve takip uyarıları",
  "profile.notif.promotions": "Promosyonlar",
  "profile.notif.promotions.desc": "Fuar fırsatları ve sponsor teklifleri",
  "profile.export": "Verilerimi Dışa Aktar",
  "profile.export.desc": "Notları ve kişileri indir",
  "profile.privacy": "Gizlilik Ayarları",
  "profile.privacy.desc": "Veri kullanımı ve görünürlük",
  "profile.help": "Yardım & Destek",
  "profile.help.desc": "SSS ve iletişim",
  "profile.about": "ExpoFlow AI Hakkında",
  "profile.about.desc": "Sürüm 2.4.1",
  "profile.signout": "Çıkış Yap",
  "profile.footer": "ExpoFlow AI • v2.4.1 • Fuar profesyonelleri için",
  "profile.language": "Dil Seçimi",
  "lang.tr": "Türkçe",
  "lang.de": "Deutsch",
  "lang.en": "English",
};

export default tr;
